module.exports = __webpack_public_path__ + "img/copper6.908420b8.gif";